
const redirects = [
  {
    from: "SubPages",
    to: "LandingPages"
  },
  {
    from: "SubPagesTemplate",
    to: "LandingPagesTemplate"
  },
]
export function routerRedirects(to, from, next) {
  const routerName = to.name;
  const redirect = redirects.find(r => r.from === routerName)
  if (redirect) {
    next({name: redirect.to, query: to.query, params: to.params});
  } else {
    next()
  }
};
